var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FFC866"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7626_33922)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "translate(7 7)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2305 13.6297C23.3189 13.6297 23.3912 13.5574 23.3912 13.469V12.2637C23.3912 12.1753 23.3189 12.103 23.2305 12.103H19.9358V8.76814C19.9358 8.67974 19.8635 8.60742 19.7751 8.60742H18.4894C18.401 8.60742 18.3287 8.67974 18.3287 8.76814V12.103H13.7483V8.76814C13.7483 8.67974 13.676 8.60742 13.5876 8.60742H12.3019C12.2135 8.60742 12.1412 8.67974 12.1412 8.76814V12.103H8.76618C8.67779 12.103 8.60547 12.1753 8.60547 12.2637V13.469C8.60547 13.5574 8.67779 13.6297 8.76618 13.6297H12.1412V18.3708H8.76618C8.67779 18.3708 8.60547 18.4431 8.60547 18.5315V19.7369C8.60547 19.8253 8.67779 19.8976 8.76618 19.8976H12.1412V23.2324C12.1412 23.3208 12.2135 23.3931 12.3019 23.3931H13.5876C13.676 23.3931 13.7483 23.3208 13.7483 23.2324V19.8976H18.3287V23.2324C18.3287 23.3208 18.401 23.3931 18.4894 23.3931H19.7751C19.8635 23.3931 19.9358 23.3208 19.9358 23.2324V19.8976H23.2305C23.3189 19.8976 23.3912 19.8253 23.3912 19.7369V18.5315C23.3912 18.4431 23.3189 18.3708 23.2305 18.3708H19.9358V13.6297H23.2305ZM18.3287 18.3708H13.7483V13.6297H18.3287V18.3708Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7626_33922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/Hash.3663040547e3d0753b08d02c7fa2b234.svg";
export { ForwardRef as ReactComponent };